import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cursor_up",
  "use": "icon-cursor_up-usage",
  "viewBox": "0 0 25 21.667",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 21.667\" id=\"icon-cursor_up\"><defs><style>#icon-cursor_up .a{fill:#d5d5d5;}</style></defs><path class=\"a\" d=\"M10.768,3a2,2,0,0,1,3.465,0L23.27,18.667a2,2,0,0,1-1.732,3H3.463a2,2,0,0,1-1.732-3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol